import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { Utils } from "src/app/utils/utils";
import { environment } from "src/environments/environment";

@Injectable({providedIn: "root"})
export class KpiProductHierarchyMappingService  {

    private readonly API_KPIPRODUCTHIERARCHY = 'api/kpiproducthierarchy';

    constructor(private readonly http: HttpClient) {}

    getAllKpiProductsHierarchyMapping(): Observable<KpiProductHierarchyMapping[]> {
        return this.http.get<KpiProductHierarchyMapping[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/mapping').pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/mapping', error);
                return throwError(() => error);
            })
        );
    }

    getKpiProductHierarchyMappingHistory(productMappingId: number): Observable<KpiProductHierarchyMappingHistory[]> {
        return this.http.get<KpiProductHierarchyMappingHistory[]>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/historyMapping/' + productMappingId).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/historyMapping/' + productMappingId, error);
                return throwError(() => error);
            })
        );
    }

    updateKpiProductHierarchyMapping(productsMapping: KpiProductHierarchyMapping[]): Observable<boolean> {
        return this.http.put<boolean>(environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/update/productMapping', productsMapping).pipe(
            catchError(error => {
                Utils.writeLog(this.http, environment.endpoint + this.API_KPIPRODUCTHIERARCHY + '/update/productMapping', error);
                return throwError(() => error);
            })
        );
    }
}